import React from 'react';
import { Zap, Brain, Battery } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 bg-slate-900 text-white px-4 sm:px-6 lg:px-8" data-id="element-68">
      <div className="max-w-7xl mx-auto" data-id="element-69">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-70">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-71">
            El secreto neurocientífico que las apps de fitness no te cuentan
          </h2>
          <p className="text-xl text-slate-300" data-id="element-72">
            Por qué el ejercicio es la cura para tu agotamiento mental, no el
            problema.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-73">
          <div className="bg-slate-800 p-8 rounded-2xl border border-slate-700" data-id="element-74">
            <div className="bg-rose-600 w-12 h-12 rounded-lg flex items-center justify-center mb-6" data-id="element-75">
              <Brain className="h-6 w-6 text-white" data-id="element-76" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-77">El Engaño Mental</h3>
            <p className="text-slate-400" data-id="element-78">
              Tu cerebro te dice "estoy cansado" para ahorrar energía. Pero es
              fatiga mental, no física. El movimiento es lo único que puede
              recargarte.
            </p>
          </div>

          <div className="bg-slate-800 p-8 rounded-2xl border border-slate-700 transform md:-translate-y-4 shadow-xl shadow-rose-900/20" data-id="element-79">
            <div className="bg-rose-600 w-12 h-12 rounded-lg flex items-center justify-center mb-6" data-id="element-80">
              <Zap className="h-6 w-6 text-white" data-id="element-81" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-82">La Regla de 5 Segundos</h3>
            <p className="text-slate-400" data-id="element-83">
              Existe una ventana de 5 segundos antes de que tu cerebro mate la
              idea de actuar. Aprenderás a moverte antes de que la duda entre.
            </p>
          </div>

          <div className="bg-slate-800 p-8 rounded-2xl border border-slate-700" data-id="element-84">
            <div className="bg-rose-600 w-12 h-12 rounded-lg flex items-center justify-center mb-6" data-id="element-85">
              <Battery className="h-6 w-6 text-white" data-id="element-86" />
            </div>
            <h3 className="text-xl font-bold mb-4" data-id="element-87">Energía Infinita</h3>
            <p className="text-slate-400" data-id="element-88">
              Al romper el ciclo de sedentarismo, activas hormonas que te dan
              más energía que cualquier café o bebida energética.
            </p>
          </div>
        </div>

        <div className="text-center bg-gradient-to-r from-rose-900 to-purple-900 p-8 rounded-2xl" data-id="element-89">
          <h3 className="text-2xl font-bold mb-4" data-id="element-90">
            Presentamos: El Interruptor Neuro-Físico
          </h3>
          <p className="text-lg text-rose-100 max-w-2xl mx-auto" data-id="element-91">
            Un método diseñado para identificar el micro-segundo exacto donde tu
            mente decide rendirse e instalar un "Interruptor de Acción" que
            desactiva la flojera al instante.
          </p>
        </div>
      </div>
    </section>;
}